/**
 * API Configuration
 * BASE_URL'i buradan kolayca değiştirebilirsiniz
 */

export const API_CONFIG = {
  BASE_URL: 'https://unimateapi.online',
  // Production için:
  // BASE_URL: 'https://api.unimate.com',
  
  ENDPOINTS: {
    // Admin Auth
    ADMIN_LOGIN: '/api/admin/login-admin',
    ADMIN_CREATE: '/api/admin/create-new-admin',
    
    // User Management
    GET_ALL_USERS: '/api/admin/users',
    GET_USER_DETAILS: '/api/admin/users/:userId',
    SEND_WARNING: '/api/admin/users/send-warning',
    BAN_USER: '/api/admin/users/:userId/ban',
    DELETE_USER: '/api/admin/users/:userId',
    UPDATE_USER: '/api/admin/users/:userId',
    GIVE_PREMIUM_TO_USER: '/api/admin/users/give-premium-to-user',
    GET_USER_POSTS_STATS: '/api/admin/users/:userId/posts-stats',
    GET_USER_POSTS: '/api/admin/users/:userId/posts',
    DELETE_POST: '/api/admin/posts/:postId',
    
    // Group Request Management
    GET_ALL_GROUP_REQUESTS: '/api/admin/group-requests',
    GET_GROUP_REQUEST_DETAIL: '/api/admin/group-requests/:requestId',
    APPROVE_GROUP_REQUEST: '/api/admin/group-requests/:requestId/approve',
    REJECT_GROUP_REQUEST: '/api/admin/group-requests/:requestId/reject',
    
    // Group Management
    GET_ALL_GROUPS: '/api/admin/groups',
    CREATE_GROUP: '/api/admin/groups',
    GET_GROUP_DETAIL: '/api/admin/groups/:chatId',
    UPDATE_GROUP: '/api/admin/groups/:chatId',
    DELETE_GROUP: '/api/admin/groups/:chatId',
    ACTIVATE_GROUP: '/api/admin/groups/:chatId/activate',
    GET_GROUP_MESSAGES: '/api/admin/groups/:chatId/messages',
    DELETE_GROUP_MESSAGE: '/api/admin/groups/:chatId/messages/:messageId',
    
    // Report Management
    GET_ALL_REPORTS: '/api/admin/reports',
    GET_REPORT_DETAIL: '/api/admin/reports/:reportId',
    RESOLVE_REPORT: '/api/admin/reports/:reportId/resolve',
    DELETE_REPORT: '/api/admin/reports/:reportId',
    GET_USER_REPORTS: '/api/admin/reports/user/:userId',
    
    // ETC Management (Cities, Universities, App Config)
    GET_INITIAL_CONFIG: '/api/etc/get-initial-config',
    ADD_CITIES: '/api/etc/admin/cities',
    UPDATE_CITIES: '/api/etc/admin/cities',
    DELETE_CITY: '/api/etc/admin/cities/:plateCode',
    ADD_UNIVERSITIES: '/api/etc/admin/universities',
    UPDATE_UNIVERSITIES: '/api/etc/admin/universities',
    DELETE_UNIVERSITY: '/api/etc/admin/universities/:universityId',
    UPDATE_APP_CONFIG: '/api/etc/admin/app-config',
    UPDATE_SOCIAL_MEDIA_LINKS: '/api/etc/admin/social-media-links',
    UPDATE_STORE_URLS: '/api/etc/admin/store-urls',
  }
};

export default API_CONFIG;

